import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import * as React from 'react';

import { AdfoxBannerParallaxBetweenOffers } from '../../components/AdfoxBanner';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from '../../constants/adBannerMicrofrontend';
import { useApplicationContext } from '../../utils/applicationContext';
import { AdBannerMicrofrontendParallaxBetweenOffersContainer } from '../AdBannerMicrofrontendParallaxBetweenOffersContainer';

type TBannerParallaxBetweenOffersContainerProps = {
  position: number;
};

/**
 * Фича-флаговый шов: манифест в конфиге есть — рендерим микрофронтенд ad-banner-frontend,
 * нет — легаси-баннер на @cian/adfox-component.
 */
export const BannerParallaxBetweenOffersContainer: React.FC<TBannerParallaxBetweenOffersContainerProps> = ({
  position,
}) => {
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);

  return manifest ? (
    <AdBannerMicrofrontendParallaxBetweenOffersContainer manifest={manifest} position={position} />
  ) : (
    <AdfoxBannerParallaxBetweenOffers position={position} />
  );
};
